// React
import React, { useState } from "react";
// React
// CSS
import styles from "./QuestionCard.module.css";
// CSS
// Models
import { I_QuizMakerQuestions } from "../../../Models/interfaces";
// Models
// Modules
import parse from "html-react-parser";
// Modules
// import QuestionModalForShowQuestion from "./QuestionModalForShowQuestion/QuestionModalForShowQuestion";

type QuestionCardProps = {
  question: I_QuizMakerQuestions;
  className?: string;
  onAnswerSelect: (aId: number | string) => "selected" | "removed";
  isSelected: string;
  currQuestion: number;
  currLessonName?: string;
  setModalData: React.Dispatch<React.SetStateAction<string>>;
  setIsModalInScreen: React.Dispatch<React.SetStateAction<boolean>>;
};

const QuestionCard: React.FunctionComponent<QuestionCardProps> = ({
  question: { image_url, title, options },
  className,
  onAnswerSelect,
  isSelected,
  currQuestion,
  currLessonName,
  setModalData,
  setIsModalInScreen,
}) => {
  const [selectedAnswerId, setSelectedAnswerId] = useState<number>();

  return (
    <>
      <div
        className={`${styles.questionCard} ${className} my-8 first-of-type:mt-0 w-11/12 p-2 rounded-lg `}
      >
        <div className="w-full flex flex-row items-center justify-between pb-4">
          <span className="text-white text-xs rounded-full bg-purple-500 w-5 h-5 flex items-center justify-center">
            {currQuestion}
          </span>
          <span className="text-xs text-gray-500">{currLessonName}</span>
        </div>
        <div
          className="w-full pb-2"
          style={{
            borderBottom: "1px solid #858585",
          }}
        >
          {title !== null ? (
            <p className="mt-4" style={{ direction: "rtl" }}>
              {/* {title ? title.replace(/(<([^>]+)>)/gi, "") : ""} */}
              {title === null ? "" : parse(String(title))}
            </p>
          ) : null}
          {image_url ? (
            <div>
              <img
                src={image_url.replace(/(http[^\s])/i, "https:").replace("::", ":")}
                alt="question Img"
                className={`${styles.questionImage} w-full my-6`}
                onClick={() => {
                  if (window.innerWidth > 600) return;
                  setModalData(image_url.replace(/(http[^\s])/i, "https:").replace("::", ":"));
                  setIsModalInScreen(true);
                }}
              />
            </div>
          ) : null}
        </div>
        {options.map((item, index) => (
          <div
            key={item.id}
            className={`${styles.optionContainer} mr-2 py-1 flex flex-row items-center justify-between w-11/12 `}
          >
            <div
              className="flex flex-row-reverse items-center mt-6 first-of-type:mt-4 cursor-pointer  justify-between w-full relative"
              onClick={() => {
                const result = onAnswerSelect(item.id);
                if (result === "selected") {
                  setSelectedAnswerId(item.id);
                  return;
                }
                setSelectedAnswerId(0);
              }}
            >
              <>
                {item.image_url ? (
                  <div style={{ direction: "rtl", marginRight: "3rem" }}>
                    <img
                      src={item.image_url.replace(/(http[^\s])/i, "https:").replace("::", ":")}
                      alt=""
                      className={`${styles.optionImage} `}
                      onDoubleClick={() => {
                        if (window.innerWidth > 600) return;
                        setModalData(
                          item.image_url
                            ? item.image_url.replace(/(http[^\s])/i, "https:").replace("::", ":")
                            : ""
                        );
                        setIsModalInScreen(true);
                      }}
                    />
                  </div>
                ) : null}
                {item.title ? (
                  <>
                    <div
                      className="mr-3 flex justify-center items-center text-base text-right"
                      style={{ direction: "rtl", marginRight: "2rem" }}
                    >
                      {parse(String(item.title))}
                    </div>
                    <br />
                  </>
                ) : null}
                <input
                  type="checkbox"
                  onChange={() => {}}
                  checked={selectedAnswerId === item.id}
                  className={`${styles.customInput}`}
                />
              </>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default QuestionCard;
